const medium = {
  state: {
    search: "",
    search_media: "",
    search_template: "",
    loading: false,
    items: [],
    next_page: "",
    show: false,
    selected: [],
    tab: 0,
    type: null,
  },
  mutations: {
    setMediumShow(state, val) {
      state.show = val;
    },
    setSelectedMedia(state, val) {
      state.selected = val;
    },
    setMediumTab(state, val) {
      state.tab = val;
    },
    setMediumSearch(state, val) {
      state.search = val;
    },
    setMediumSearchLoading(state, val) {
      state.loading = val;
    },
    setMediumSearchMedia(state, val) {
      state.search_media = val;
    },
    setMediumSearchTemplate(state, val) {
      state.search_template = val;
    },
    setMediumNextPage(state, val) {
      state.next_page = val;
    },
    setMediumItems(state, val) {
      state.items = val;
    },
    setMediumType(state, val) {
      state.type = val;
      state.show = true;
    },
    clearMedium(state) {
      state.search = "";
      state.loading = false;
      state.items = [];
      state.next_page = "";
      state.show = false;
      state.tab = 0;
      state.search_media = "";
      state.search_template = "";
    },
  },
  actions: {
    async selectMedia({ commit, state }, media) {
      media.map((val) => {
        if (state.type === "template.background") {
          commit("setTemplateBackground", val);
          commit("setMediumShow", false);
          commit("setSelectedMedia", []);
        } else if (state.type.includes("template.block")) {
          commit("setTemplateBlock", {
            index: Number(state.type.split(".")[2]),
            ...val,
          });
          commit("setMediumShow", false);
          commit("setSelectedMedia", []);
        } else if (state.type === "post") {
          let media = val;
          if (val.type === "stock") {
            media.src = media.src.large;
          }
          if (val.type === "template") {
            commit("setPostTemplateDialog", true);
          }
          commit("addPostMedia", media);
          commit("setMediumShow", false);
          commit("setSelectedMedia", []);
        }
      });
    },
  },
  getters: {},
};

export default medium;
